import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import basculeHoganFiservEnum from '../../constantes/bascule-hogan-fiserv.enum';
import { ActivatedRoute } from '@angular/router';

const OEL_CAAD_BASCULE_HOGAN_FISERV = 'oel-caad-bascule-hogan-fiserv';

@Component({
  selector: 'app-bascule-hogan-fiserv',
  templateUrl: './bascule-hogan-fiserv.component.html',
  standalone: false,
})
export class BasculeHoganFiservComponent implements OnInit {
  estSplitFiservOuverte: boolean;
  component: Component;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly configService: ConfigurationService
  ) {}

  ngOnInit(): void {
    this.estSplitFiservOuverte = this.configService.isConfigEqualValue(
      OEL_CAAD_BASCULE_HOGAN_FISERV,
      basculeHoganFiservEnum.FISERV.valueOf()
    );
    this.activatedRoute.data.subscribe((data) => {
      this.component = this.estSplitFiservOuverte ? data.componentFiserv : data.componentHogan;
    });
  }
}
